export const locale = {
  lang: 'en',
  user_inactivity: {
    STAY_CONNECTED: 'Permanecer conectado',
    INACTIVE_SESSION: 'Su sesión se desconectará debido a inactividad',
    CONNECTING: 'Conectando...',
  }
};
